import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { CKEditorModule } from 'ckeditor4-angular';

import { MaterialModule } from '../material.module';
import { InputControlComponent } from '../controls/input-control/input-control.component';
import { GridControlComponent } from '../controls/grid-control/grid-control.component';
import { ModalControl } from '../controls/modal-control/modal-control.component';
import { SelectControlComponent } from '../controls/select-control/select-control.component';
import { DatePickerControlComponent } from '../controls/date-picker-control/date-picker-control.component';
import { ModalHeaderComponent } from '../controls/modal-control/modal-header/modal-header.component';
import { ModalBodyComponent } from '../controls/modal-control/modal-body/modal-body.component';
import { ModalFooterComponent } from '../controls/modal-control/modal-footer/modal-footer.component';
import { UploadExcelControlComponent } from '../controls/upload-excel-control/upload-excel-control.component';
import { AutocompleteControlComponent } from '../controls/autocomplete-control/autocomplete-control.component';
import { GridDatePickerControlComponent } from '../controls/grid-control/components/grid-date-picker-control/grid-date-picker-control.component';
import { HandlerLocal } from '../controls/grid-control/handlers/handler-local';
import { HandlerDotnet } from '../controls/grid-control/handlers/handler-dotnet';
import { CheckboxControlComponent } from '../controls/checkbox-control/checkbox-control.component';
import { SwitchControlComponent } from '../controls/switch-control/switch-control.component';
import { RadioControlComponent } from '../controls/radio-control/radio-control.component';
import { GridConfigComponent } from '../controls/grid-control/components/grid-config/grid-config.component';
import { GridImportExcelComponent } from '../controls/grid-control/components/grid-import-excel/grid-import-excel.component';
import { CkeditorControlComponent } from '../controls/ckeditor-control/ckeditor-control.component';
import { EditorHandlerPipe } from '../controls/grid-control/pipes/editor-handler.pipe';
import { UploadExcelConfigComponent } from '../controls/upload-excel-control/dependencies/upload-excel-config/upload-excel-config.component';
import { GridAutocompleteControl } from '../controls/grid-control/components/grid-autocomplete-control/grid-autocomplete-control.component';
import { GridPopupEditorComponent } from '../controls/grid-control/components/grid-popup-editor/grid-popup-editor.component';
import { FilterMobilePipe } from '../controls/grid-control/pipes/filter-mobile.pipe';
import { GridPopupFilterComponent } from '../controls/grid-control/components/grid-popup-filter/grid-popup-filter.component';
import { ChartControlComponent } from '../controls/chart-control/chart-control.component';
import { ChipControlComponent } from '../controls/chip-control/chip-control.component';
import { GridSubInformationComponent } from '../controls/grid-control/components/grid-sub-information/grid-sub-information.component';
import { SdMinDateValidator } from '../validators/min-date.validator';
import { SdMaxDateValidator } from '../validators/max-date.validator';
import { SdCustomValidator } from '../validators/custom.validator';
import { CommandIconPipe } from '../controls/grid-control/pipes/command-icon.pipe';
import { CommandTitlePipe } from '../controls/grid-control/pipes/command-title.pipe';
import { CommandDisabledPipe } from '../controls/grid-control/pipes/command-disabled.pipe';
import { CommandHidden } from '../controls/grid-control/pipes/command-hidden.pipe';
import { MobileCommandFilterPipe } from '../controls/grid-control/pipes/mobile-command-filter';
import { ColumnTitlePipe } from '../controls/grid-control/pipes/column-title.pipe';
import { SdChipMinItemValidator } from '../validators/chip-min-item.validator';
import { EditorValidatePipe } from '../controls/grid-control/pipes/editor-validate.pipe';
import { EditorDynamicItemPipe } from '../controls/grid-control/pipes/editor-dynamic-item.pipe';
import { ColumnHtmlTemplatePipe } from '../controls/grid-control/pipes/column-html-template.pipe';
import { ColumnCommandFilterPipe } from '../controls/grid-control/pipes/column-command-filter.pipe';
import { UploadFileControlComponent } from '../controls/upload-file-control/upload-file-control.component';
import '../typings';
// tslint:disable-next-line: max-line-length
import { GridPopupExportExcelComponent } from '../controls/grid-control/components/grid-popup-export-excel/grid-popup-export-excel.component';
import { SdInputTooltipPipe } from '../pipes/input-tooltip.pipe';
import { CellMobileClassNamePipe } from '../controls/grid-control/pipes/cell-mobile-class-name.pipe';
import { ValueTransformPipe } from '../controls/grid-control/pipes/value-transform.pipe';
import { EditorSubInformationHandlerPipe } from '../controls/grid-control/pipes/editor-sub-information-handler.pipe';
// tslint:disable-next-line: max-line-length
import { GridDesktopColumnViewComponent } from '../controls/grid-control/components/grid-desktop-column-view/grid-desktop-column-view.component';
// tslint:disable-next-line: max-line-length
import { GridDesktopColumnEditComponent } from '../controls/grid-control/components/grid-desktop-column-edit/grid-desktop-column-edit.component';
// tslint:disable-next-line: max-line-length
import { GridDesktopInlineFilterComponent } from '../controls/grid-control/components/grid-desktop-inline-filter/grid-desktop-inline-filter.component';
import { CellDesktopClassNamePipe } from '../controls/grid-control/pipes/cell-desktop-class-name.pipe';
// tslint:disable-next-line: max-line-length
import { GridDesktopColumnChildrenViewComponent } from '../controls/grid-control/components/grid-desktop-column-children-view/grid-desktop-column-children-view.component';
// tslint:disable-next-line: max-line-length
import { GridMobileItemViewComponent } from '../controls/grid-control/components/grid-mobile-item-view/grid-mobile-item-view.component';
import { DateRangePickerControlComponent } from '../controls/date-range-picker-control/date-range-picker-control.component';
import { BottomSheetComponent } from '../controls/bottom-sheet/bottom-sheet.component';
import { BottomSheetBodyComponent } from '../controls/bottom-sheet/bottom-sheet-body/bottom-sheet-body.component';
import { BottomSheetFooterComponent } from '../controls/bottom-sheet/bottom-sheet-footer/bottom-sheet-footer.component';
import { BottomSheetHeaderComponent } from '../controls/bottom-sheet/bottom-sheet-header/bottom-sheet-header.component';
import { ButtonComponent } from '../controls/button/button.component';
import { DesktopDirective, MobileDirective, TabletDirective, MobileTabletDirective } from '../directives';
// tslint:disable-next-line: max-line-length
import { GridPopupQuickFilterDetailComponent } from '../controls/grid-control/components/grid-popup-quick-filter-detail/grid-popup-quick-filter-detail.component';
import { CommandFilterPipe } from '../controls/grid-control/pipes/command-filter.pipe';
import { MobileViewHtmlTemplatePipe } from '../controls/grid-control/pipes/mobile-view-html-template.pipe';
import { LabelComponent, TextareaControlComponent } from '../controls';
import { GridInputControlComponent } from '../controls/grid-control/components/grid-input-control/grid-input-control.component';
import { SdServiceModule } from './sd-service.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    CKEditorModule,
    DeviceDetectorModule.forRoot(),
    SdServiceModule.forChild()
  ],
  declarations: [
    GridControlComponent,
    GridConfigComponent,
    GridPopupExportExcelComponent,
    GridImportExcelComponent,
    GridPopupEditorComponent,
    GridSubInformationComponent,
    GridDesktopColumnViewComponent,
    GridDesktopColumnEditComponent,
    GridDesktopColumnChildrenViewComponent,
    GridDesktopInlineFilterComponent,
    GridMobileItemViewComponent,
    GridInputControlComponent,
    UploadExcelConfigComponent,
    UploadExcelControlComponent,
    InputControlComponent,
    SelectControlComponent,
    ModalControl,
    DatePickerControlComponent,
    DateRangePickerControlComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    AutocompleteControlComponent,
    GridDatePickerControlComponent,
    GridAutocompleteControl,
    GridPopupFilterComponent,
    GridPopupQuickFilterDetailComponent,
    DesktopDirective,
    MobileDirective,
    TabletDirective,
    MobileTabletDirective,
    CheckboxControlComponent,
    SwitchControlComponent,
    RadioControlComponent,
    CkeditorControlComponent,
    ChartControlComponent,
    ChipControlComponent,
    UploadFileControlComponent,
    BottomSheetComponent,
    BottomSheetBodyComponent,
    BottomSheetFooterComponent,
    BottomSheetHeaderComponent,
    ButtonComponent,
    LabelComponent,
    TextareaControlComponent,
    // Pipes
    EditorHandlerPipe,
    EditorValidatePipe,
    EditorDynamicItemPipe,
    FilterMobilePipe,
    MobileCommandFilterPipe,
    ColumnHtmlTemplatePipe,
    ColumnTitlePipe,
    CommandIconPipe,
    CommandTitlePipe,
    CommandDisabledPipe,
    CommandHidden,
    CommandFilterPipe,
    ColumnCommandFilterPipe,
    CellMobileClassNamePipe,
    CellDesktopClassNamePipe,
    MobileViewHtmlTemplatePipe,
    SdInputTooltipPipe,
    ValueTransformPipe,
    EditorSubInformationHandlerPipe,
    // Validators
    SdMinDateValidator,
    SdMaxDateValidator,
    SdCustomValidator,
    SdChipMinItemValidator
  ],
  exports: [
    MaterialModule,
    // Controls
    TextareaControlComponent,
    InputControlComponent,
    SelectControlComponent,
    DatePickerControlComponent,
    DateRangePickerControlComponent,
    GridControlComponent,
    UploadExcelControlComponent,
    AutocompleteControlComponent,
    ModalControl,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    CheckboxControlComponent,
    SwitchControlComponent,
    RadioControlComponent,
    CkeditorControlComponent,
    ChartControlComponent,
    ChipControlComponent,
    UploadFileControlComponent,
    BottomSheetComponent,
    BottomSheetBodyComponent,
    BottomSheetFooterComponent,
    BottomSheetHeaderComponent,
    ButtonComponent,
    LabelComponent,
    // Directives
    DesktopDirective,
    MobileDirective,
    TabletDirective,
    MobileTabletDirective,
  ],
  providers: [
    DatePipe,
    HandlerLocal,
    HandlerDotnet,
    EditorHandlerPipe
  ]
})
export class SdControlModule {}
